import { useRef } from 'react'
import { Modal } from 'react-daisyui'
import { Button } from '@/components/Button.tsx'
import { IconCrop } from '@tabler/icons-react'

interface CropConfirmModalProps {
  onConfirm: () => void
  isLoading?: boolean
}

export function useCropConfirmModal() {
  const modalRef = useRef<HTMLDialogElement>(null)

  const show = () => modalRef.current?.showModal()
  const close = () => modalRef.current?.close()

  return { modalRef, show, close }
}

export function CropConfirmModal({
  modalRef,
  onConfirm,
  isLoading
}: CropConfirmModalProps & { modalRef: React.RefObject<HTMLDialogElement> }) {
  return (
    <Modal ref={modalRef} responsive className='bg-neutral'>
      <Modal.Header className='flex flex-col items-center gap-3 pt-6'>
        <div className='bg-primary bg-opacity-20 text-primary rounded-full p-4'>
          <IconCrop size={36} />
        </div>
        <span className='text-xl font-bold text-center'>Bildzuschnitt bestätigen</span>
      </Modal.Header>
      <Modal.Body>
        <div className='text-center px-4'>
          <p className='text-base-content opacity-80'>
            Bitte bestätige, dass du die Bildzuschnitte geprüft hast - wir drucken so, wie es hier aussieht. <br />Fehlerhafte Zuschnitte sind vom Rückgaberecht ausgeschlossen.
          </p>
        </div>
      </Modal.Body>
      <Modal.Actions className='flex flex-row gap-3 justify-center pb-6'>
        <form method="dialog">
          <Button color='ghost'>
            Nochmal prüfen
          </Button>
        </form>
        <Button color='primary' onClick={onConfirm} loading={isLoading} disabled={isLoading}>
          Bestätigen
        </Button>
      </Modal.Actions>
    </Modal>
  )
}
